import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {

    public rangeList = ['Today', 'Yesterday', 'This week', 'This month', 'Year to Date', 'Q1', 'Q2', 'Q3', 'Q4', 'Custom']

    public fromDate: any
    public dateType: any
    public toDate: any

    @Input() set dateFilterSelect(name: string) {
        if (name) {
            this.dateType = name
            this.rangeDate(name)
        }
    }

    @Output() getDate: EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit(): void {

    }


    rangeDate(range: any, date: any = undefined) {
        switch (range) {
            case 'Today':
                this.fromDate = moment().startOf('day').format('YYYY-MM-DD');
                this.toDate = moment().format('YYYY-MM-DD');
                break;
            case 'Yesterday':
                this.fromDate = moment().subtract(2, 'days').format('YYYY-MM-DD');
                this.toDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                break;
            case 'This week':
                this.fromDate = moment().startOf('week').format('YYYY-MM-DD');
                this.toDate = moment().format('YYYY-MM-DD');
                break;
            case 'This month':
                this.fromDate = moment().startOf('month').format('YYYY-MM-DD');
                this.toDate = moment().format('YYYY-MM-DD');
                break;
            case 'Year to Date':
                this.fromDate = moment().startOf('year').format('YYYY-MM-DD');
                this.toDate = moment().format('YYYY-MM-DD');
                break;
            case 'Q1':
                this.fromDate = this.getQuarterRange(1).start
                this.toDate = this.getQuarterRange(1).end
                break;
            case 'Q2':
                this.fromDate = this.getQuarterRange(2).start
                this.toDate = this.getQuarterRange(2).end
                break;
            case 'Q3':
                this.fromDate = this.getQuarterRange(3).start
                this.toDate = this.getQuarterRange(3).end
                break;
            case 'Q4':
                this.fromDate = this.getQuarterRange(4).start
                this.toDate = this.getQuarterRange(4).end
                break;
            default:
                if (range == 'Custom') {
                    this.fromDate = undefined
                    this.toDate = undefined
                } else {
                    if (date) {
                        this.fromDate = moment(date[0]).format('YYYY-MM-DD');
                        this.toDate = moment(date[1]).format('YYYY-MM-DD');
                    }
                }
                break;

        }

        this.getDate.next({
            fromDate: this.fromDate,
            toDate: this.toDate,
            dateFilterSelect: this.dateType
        });
    }

    getQuarterRange(quarter: number) {

        if (quarter == 1) {
            return { start: moment().month(3).startOf('month').format('YYYY-MM-DD'), end: moment().month(5).endOf('month').format('YYYY-MM-DD') }
        }
        else if (quarter == 2) {
            return { start: moment().month(6).startOf('month').format('YYYY-MM-DD'), end: moment().month(8).endOf('month').format('YYYY-MM-DD') }
        }
        else if (quarter == 3) {
            return { start: moment().month(9).startOf('month').format('YYYY-MM-DD'), end: moment().month(11).endOf('month').format('YYYY-MM-DD') }
        }
        else if (quarter == 4) {
            return { start: moment().month(0).startOf('month').add(1, 'years').format('YYYY-MM-DD'), end: moment().month(2).endOf('month').add(1, 'years').format('YYYY-MM-DD') }
        } else {
            return {}
        }

        // const start = moment().utc().quarter(quarter).startOf('quarter').format('YYYY-MM-DD');
        // const end = moment().utc().quarter(quarter).endOf('quarter').format('YYYY-MM-DD');
        // return { start, end };
    }
}
